import { OfferedProduct } from 'src/graphql';
import { TRIAL_MEMBERSHIP_PLATFORM_SLA_IDS } from './const';

/**
 * The pilot's plan list: the partner's offered products narrowed to the
 * allowed memberships. Filter on platformSlaId, never displayName - display
 * names are not stable ("Essentials+" vs "Essentials Plus").
 */
export function getTrialProducts(offeredProducts?: OfferedProduct[]): OfferedProduct[] {
  return (offeredProducts ?? [])
    .filter((product) => TRIAL_MEMBERSHIP_PLATFORM_SLA_IDS.includes(product.platformSlaId))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
}
